import { Component, OnInit, OnDestroy, ViewChild, TemplateRef, Input,
  Injectable, PLATFORM_ID, Inject } from '@angular/core';
import { isPlatformBrowser } from '@angular/common';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { Router } from '@angular/router';
import { NaviFreshMartService } from '../../../services/navi-fresh-mart.service';
import { address } from 'src/app/shared/classes/address';
import { AlertService } from 'src/app/shared/components/alert';

@Component({
  selector: 'app-address-modal',
  templateUrl: './address-modal.component.html',
  styleUrls: ['./address-modal.component.scss']
})
export class AddressModalComponent implements OnInit, OnDestroy  {


  @ViewChild("addressModal", { static: false }) AddressModal: TemplateRef<any>;
  selectedValue: string = 'Title';
  geocoder=new google.maps.Geocoder();
  loadingAction: boolean = false;
  detectLocationAction: boolean = false;
  currentLocation = "Not able To Detect Your Location!";
   SUBLOCALITY = 'sublocality';
   LOCALITY = 'locality';
   POSTAL_CODE = 'postal_code';
   addressList : any;
   user : any;
   otherType = null;

  public closeResult: string;
  public modalOpen: boolean = false;
  public counter: number = 1;
  public ImageSrc: string;
  public addressType: string = "";
  public address: any = {};
  public showOtherBox = false;
  public addAddress = false;
  public editAddress = false;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private router: Router, private modalService: NgbModal, private productItemsService: NaviFreshMartService,
    private alertService: AlertService
    ) { 
      this.user = JSON.parse(localStorage.getItem('user'));
    }

  ngOnInit(): void {
  }

  changeDropdownName(value: string) {
    this.selectedValue = value;
  }

  

  openModal() {
    this.addAddress = true;
    this.editAddress = false;
    this.showOtherBox = false;
    this.modalOpen = true;
    if (isPlatformBrowser(this.platformId)) { // For SSR 
      this.modalService.open(this.AddressModal, { 
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'Quickview' 
      }).result.then((result) => {
        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  editModal(address) {
    this.addAddress = false;
    this.editAddress = true;
    this.modalOpen = true;
    this.address = address;
    this.address.defaultAddress = (this.address.defaultAddress == "true" ||  this.address.defaultAddress == true) ? true : false;
    this.otherType = (this.address.addressType != 'Home' && this.address.addressType != 'Office') ? 'Other' : null;
    if(this.otherType == "Other") {
      this.showOtherTextBox(true);
    }
    this.addressType = (this.address.addressType != 'Home' && this.address.addressType != 'Office') ? this.address.addressType : "";
    if (isPlatformBrowser(this.platformId)) { // For SSR 
      this.modalService.open(this.AddressModal, { 
        ariaLabelledBy: 'modal-basic-title',
        centered: true,
        windowClass: 'Quickview' 
      }).result.then((result) => {
        `Result ${result}`
      }, (reason) => {
        this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
      });
    }
  }

  changeAddressType(type) {
    this.address.addressType = type;
  }
  closeAddressModal() {
    this.address = {};
    this.showOtherTextBox(false);
    this.modalService.dismissAll();
  }

  showOtherTextBox(val) {
    this.showOtherBox = val;
  }
  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }  

  detectLocation() {
    this.loadingAction = true;
    window.navigator.geolocation.getCurrentPosition(
      (response) => {
        console.log("current geo location :", response);
        this.loadingAction = false;
        this.detectLocationAction = false;
        this.geocodeLatLng(response.coords.latitude,response.coords.longitude);
      },
      (error) => {
        console.log("error", error);
        this.loadingAction = false;
        this.detectLocationAction = false;
      }
    );
  }
  geocodeLatLng(latStr, longStr) {
    console.log("lat ",latStr,"long ",longStr);
    const latlng = {
      lat: parseFloat(latStr),
      lng: parseFloat(longStr),
    };
    this.geocoder.geocode(
      { location: latlng },
      (
        results: google.maps.GeocoderResult[],
        status: google.maps.GeocoderStatus
      ) => {
        if (status === "OK") {
          if (results[0]) {
            const addressComponents = results[0].address_components;
            console.log(addressComponents);
            /**
             * filteer the address components
             */
            let formattedAddress = addressComponents.filter((addressComponent)=>{
                return   addressComponent.types.find((typeData)=> typeData=== this.SUBLOCALITY || typeData=== this.LOCALITY || typeData=== this.POSTAL_CODE);
            });
            console.log(formattedAddress);
            let finalAddress ="";
            formattedAddress.forEach((element)=>{
               
                finalAddress = finalAddress.concat(element.short_name,",");
            })
           finalAddress = finalAddress.slice(0,finalAddress.length-1);
            console.log("finalAddress",finalAddress);
            this.address.locality = finalAddress || results[0].formatted_address;
            localStorage.setItem('currentLocation',this.address.locality);
            console.log("location address: ",this.address.locality);

            let formatted_address = (results[0].formatted_address);
            let tempAddress = formatted_address.split(",");
            
            let stateAndPincode = tempAddress[tempAddress.length - 2].trim();
            let state = stateAndPincode.split(" ")[0];
            let pincode = stateAndPincode.split(" ")[1];
            
            this.address.city = tempAddress[tempAddress.length - 3].trim();
            this.address.state = state;
            this.address.pincode = pincode;
          } else {
            window.alert("No results found");
          }
        } else {
          window.alert("Geocoder failed due to: " + status);
        }
      }
    );
  }
  submitAddress() {
    this.address.accountId = this.user?.accountId;
    this.address.addressType = this.showOtherBox == true ? this.addressType : this.address.addressType;
    console.log(this.address);

    let newAddress = this.address;
    this.productItemsService
      .postAddress(newAddress)
      .subscribe((data) => {
        console.log('Posted Address:', data);
        this.modalService.dismissAll();
        this.address = {};   
        this.alertService.success("Address Saved Successfully");
        this.router.navigate(['/pages/useraccount/myaddress']);
        window.location.reload();
        //this.router.navigate(['/pages/useraccount'],{ queryParams: { 'tab': "myaddress" } });
        /**
         * address list
         */
        let addressPayload: address = {
          accountId: this.user?.accountId,
          addressId: 0,
          addressType: '',
          city: '',
          defaultAddress: false,
          doorNo: '',
          landmark: '',
          locality: '',
          pincode: '',
          state: '',
        };
        this.productItemsService
          .getAddress(addressPayload)
          .subscribe((data) => {
            this.addressList = data?.addressList;
            console.log('this.addressList', this.addressList);
            if (this.addressList && !Array.isArray(this.addressList)) {
              this.addressList = [this.addressList];
              localStorage.setItem(
                'addressList',
                JSON.stringify(this.addressList)
              );
            } else {
              localStorage.setItem(
                'addressList',
                JSON.stringify(this.addressList)
              );
            }
          });   
      });
  }

  ngOnDestroy() {
    if(this.modalOpen){
      this.modalService.dismissAll();
    }
  }

}
